import "shared/extensions/date";

import { ChartFilters } from "../ChartProps";
import { ReportType } from "../../Reports/ReportConstants";
import { useGetReportFunctionRequest } from "shared/request/myHealthyAdvantageApi";

export type useGetReportProps = {
  reportType: ReportType;
  filters: ChartFilters;
};
export const useGetReport = ({ reportType, filters }: useGetReportProps) => {
  const dateToString = Date.fromDateOnly(filters.dateTo)?.toDateOnlyString()!;
  const dateFromString = Date.fromDateOnly(filters.dateFrom)?.toDateOnlyString()!;

  const query = {
    reportType: reportType.toString(),
    dateFrom: dateFromString,
    dateTo: dateToString,
    groupBy: filters.groupBy?.toString(),
    targetGroupClientIds: filters?.targetGroupClients?.map((client) => client.id),
    clientId: filters.client?.id,
    divisionId: filters.division?.id,
    localeId: filters.localeId,
  };

  return useGetReportFunctionRequest(query);
};
